// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: TEMSv3Icons;
    src: url(/fonts/TEMSFont.eot); /* IE9 Compat Modes */
    src: url(/fonts/TEMSFont.eot?#iefix) format('embedded-opentype'), /* IE6-IE8 */
         url(/fonts/TEMSFont.woff2) format('woff2'), /* Super Modern Browsers */
         url(/fonts/TEMSFont.woff) format('woff'), /* Pretty Modern Browsers */
         url(/fonts/TEMSFont.ttf)  format('truetype'), /* Safari, Android, iOS */
         url(/fonts/TEMSFont.svg#svgFontName) format('svg'); /* Legacy iOS */
}

.fa {
    vertical-align: middle;
    margin-top: auto;
    margin-bottom: auto;
}

.ti:not(.fa) {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-family: TEMSv3Icons;
    vertical-align: middle;
    margin-top: auto;
    margin-bottom: auto;
}

.ti.ti-event:before {
    content: 'a';
}

.ti.ti-attendees:before {
    content: 'b';
}

.ti.ti-event-inventory:before {
    content: 'c';
}

.ti.ti-meeting:before {
    content: 'd';
}

.ti.ti-accommodation:before {
    content: 'e';
}

.ti.ti-dining:before {
    content: 'f';
}

.ti.ti-golf-cart:before {
    content: 'g';
}

.ti.ti-badge:before {
    content: 'h';
}

.ti.ti-report:before {
    content: 'i';
}

.ti.ti-plus:before {
    content: 'j';
}

.ti.ti-minus:before {
    content: 'k';
}

.ti.ti-edit:before {
    content: 'l';
}

.ti.ti-refresh:before {
    content: 'm';
}

.ti.ti-phone:before {
    content: 'n';
}

.ti.ti-email:before {
    content: 'o';
}

.ti.ti-key:before {
    content: 'p';
}

.ti.ti-user:before {
    content: 'q';
}

.ti.ti-hamburger:before {
    content: 'r';
}

.ti.ti-notification:before {
    content: 's';
}

.ti.ti-user-alt:before {
    content: 't';
}

.ti.ti-search:before {
    content: 'u';
}

.ti.ti-daily-transport:before {
    content: 'v';
}

.ti.ti-question:before {
    content: 'x';
}

.ti.ti-gear:before {
    content: 'z';
}

.ti.ti-checked:before {
    content: 'B'
}

.ti.ti-unchecked:before {
    content: 'T'
}

.ti.ti-duplicate:before {
    content: 'D'
}

.ti.ti-active:before {
    content: 'U'
}

.ti.ti-archived:before {
    content: 'V'
}

.ti.ti-extras:before {
    content: 'X'
}

.ti.ti-cost-management:before {
    content: 'W'
}

.ti.ti-email-and-services:before {
    content: 'Z'
}

.ti.ti-hotel-configuration:before {
    content: '!'
}

.ti.ti-times:before {
    content: '['
}

.ti.ti-trash:before {
    content: ']'
}

.ti.ti-sign-out-alt:before {
    content: 'O'
}

.ti.ti-chevron-down:before {
    content: 'I'
}

.ti.ti-chevron-left:before {
    content: 'J'
}

.ti.ti-chevron-up:before {
    content: 'K'
}

.ti.ti-chevron-right:before {
    content: 'L'
}

.ti.ti-exclamation-circle:before {
    content: 'Y'
}

.ti.ti-filter:before {
    content: 'F'
}

.ti.ti-expand:before {
    content: '\$'
}

.ti.ti-compress:before {
    content: '#'
}

.ti.ti-camera:before {
    content: 'G'
}

.ti.ti-clock:before {
    content: 'H'
}

.ti.ti-download:before {
    content: 'R'
}

.ti.ti-key:before {
    content: 'S'
}

.ti.ti-calendar:before {
    content: 'P'
}

.ti.ti-check:before {
    content: 'N'
}

.ti.ti-image:before {
    content: ','
}

.ti.ti-file:before {
    content: '%'
}

.ti.ti-file-pdf:before {
    content: '('
}

.ti.ti-file-powerpoint:before {
    content: ')'
}

.ti.ti-file-word:before {
    content: '+'
}

.ti.ti-file-excel:before {
    content: '&'
}

.ti.ti-list:before {
    content: 'A'
}

.ti.ti-user-circle:before {
    content: '6'
}

.ti.ti-id-card:before {
    content: '7'
}

.ti.ti-user-group:before {
    content: '8'
}

.ti.ti-bell:before {
    content: 'Q'
}

.ti.ti-info-circle:before {
    content: '/'
}

.ti.ti-eye:before {
    content: '"'
}

.ti.ti-eye-slash:before {
    content: "'"
}

/* sizing */
.text-sm, .text-sm * {
    font-size: .75rem !important;
}

.text-xs {
    font-size: .5rem !important;
}

.text-md, .text-md * {
    font-size: 1.25rem !important;
}

.text-lg, .text-lg * {
    font-size: 1.5rem !important;
}

.text-xl, .text-xl * {
    font-size: 2rem !important;
}

.text-super, .text-super * {
    font-size: 5rem !important;
}

.text-normal, .text-normal * {
    font-size: 1rem !important;
}

.text-red {
    color: red !important;
}

.text-green {
    color: green !important;
}

.text-orange {
    color: orange !important;
}

.text-lime-green {
    color: #88ff88 !important;
}

.text-white {
    color: white !important;
}

.text-gray {
    color:#999 !important;
}

.text-blue {
    color: #005377;
}

.text-bold {
    font-weight: bold;
}

.text-italic {
    font-style: italic;
}

.text-weight-normal {
    font-weight: normal !important;
}

.text-underline {
    text-decoration: underline !important;
}

@media (max-width: 768px) {
    .text-increase-phone .btn,
    .text-increase-phone {
        font-size: 108% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,6BAA6B,EAAE,qBAAqB;IACpD;;;;2DAIuD,EAAE,eAAe;AAC5E;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,WAAW;AACX;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI;;QAEI,0BAA0B;IAC9B;AACJ","sourcesContent":["@font-face {\r\n    font-family: TEMSv3Icons;\r\n    src: url(/fonts/TEMSFont.eot); /* IE9 Compat Modes */\r\n    src: url(/fonts/TEMSFont.eot?#iefix) format('embedded-opentype'), /* IE6-IE8 */\r\n         url(/fonts/TEMSFont.woff2) format('woff2'), /* Super Modern Browsers */\r\n         url(/fonts/TEMSFont.woff) format('woff'), /* Pretty Modern Browsers */\r\n         url(/fonts/TEMSFont.ttf)  format('truetype'), /* Safari, Android, iOS */\r\n         url(/fonts/TEMSFont.svg#svgFontName) format('svg'); /* Legacy iOS */\r\n}\r\n\r\n.fa {\r\n    vertical-align: middle;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\n.ti:not(.fa) {\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    display: inline-block;\r\n    font-style: normal;\r\n    font-variant: normal;\r\n    text-rendering: auto;\r\n    line-height: 1;\r\n    font-family: TEMSv3Icons;\r\n    vertical-align: middle;\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n}\r\n\r\n.ti.ti-event:before {\r\n    content: 'a';\r\n}\r\n\r\n.ti.ti-attendees:before {\r\n    content: 'b';\r\n}\r\n\r\n.ti.ti-event-inventory:before {\r\n    content: 'c';\r\n}\r\n\r\n.ti.ti-meeting:before {\r\n    content: 'd';\r\n}\r\n\r\n.ti.ti-accommodation:before {\r\n    content: 'e';\r\n}\r\n\r\n.ti.ti-dining:before {\r\n    content: 'f';\r\n}\r\n\r\n.ti.ti-golf-cart:before {\r\n    content: 'g';\r\n}\r\n\r\n.ti.ti-badge:before {\r\n    content: 'h';\r\n}\r\n\r\n.ti.ti-report:before {\r\n    content: 'i';\r\n}\r\n\r\n.ti.ti-plus:before {\r\n    content: 'j';\r\n}\r\n\r\n.ti.ti-minus:before {\r\n    content: 'k';\r\n}\r\n\r\n.ti.ti-edit:before {\r\n    content: 'l';\r\n}\r\n\r\n.ti.ti-refresh:before {\r\n    content: 'm';\r\n}\r\n\r\n.ti.ti-phone:before {\r\n    content: 'n';\r\n}\r\n\r\n.ti.ti-email:before {\r\n    content: 'o';\r\n}\r\n\r\n.ti.ti-key:before {\r\n    content: 'p';\r\n}\r\n\r\n.ti.ti-user:before {\r\n    content: 'q';\r\n}\r\n\r\n.ti.ti-hamburger:before {\r\n    content: 'r';\r\n}\r\n\r\n.ti.ti-notification:before {\r\n    content: 's';\r\n}\r\n\r\n.ti.ti-user-alt:before {\r\n    content: 't';\r\n}\r\n\r\n.ti.ti-search:before {\r\n    content: 'u';\r\n}\r\n\r\n.ti.ti-daily-transport:before {\r\n    content: 'v';\r\n}\r\n\r\n.ti.ti-question:before {\r\n    content: 'x';\r\n}\r\n\r\n.ti.ti-gear:before {\r\n    content: 'z';\r\n}\r\n\r\n.ti.ti-checked:before {\r\n    content: 'B'\r\n}\r\n\r\n.ti.ti-unchecked:before {\r\n    content: 'T'\r\n}\r\n\r\n.ti.ti-duplicate:before {\r\n    content: 'D'\r\n}\r\n\r\n.ti.ti-active:before {\r\n    content: 'U'\r\n}\r\n\r\n.ti.ti-archived:before {\r\n    content: 'V'\r\n}\r\n\r\n.ti.ti-extras:before {\r\n    content: 'X'\r\n}\r\n\r\n.ti.ti-cost-management:before {\r\n    content: 'W'\r\n}\r\n\r\n.ti.ti-email-and-services:before {\r\n    content: 'Z'\r\n}\r\n\r\n.ti.ti-hotel-configuration:before {\r\n    content: '!'\r\n}\r\n\r\n.ti.ti-times:before {\r\n    content: '['\r\n}\r\n\r\n.ti.ti-trash:before {\r\n    content: ']'\r\n}\r\n\r\n.ti.ti-sign-out-alt:before {\r\n    content: 'O'\r\n}\r\n\r\n.ti.ti-chevron-down:before {\r\n    content: 'I'\r\n}\r\n\r\n.ti.ti-chevron-left:before {\r\n    content: 'J'\r\n}\r\n\r\n.ti.ti-chevron-up:before {\r\n    content: 'K'\r\n}\r\n\r\n.ti.ti-chevron-right:before {\r\n    content: 'L'\r\n}\r\n\r\n.ti.ti-exclamation-circle:before {\r\n    content: 'Y'\r\n}\r\n\r\n.ti.ti-filter:before {\r\n    content: 'F'\r\n}\r\n\r\n.ti.ti-expand:before {\r\n    content: '$'\r\n}\r\n\r\n.ti.ti-compress:before {\r\n    content: '#'\r\n}\r\n\r\n.ti.ti-camera:before {\r\n    content: 'G'\r\n}\r\n\r\n.ti.ti-clock:before {\r\n    content: 'H'\r\n}\r\n\r\n.ti.ti-download:before {\r\n    content: 'R'\r\n}\r\n\r\n.ti.ti-key:before {\r\n    content: 'S'\r\n}\r\n\r\n.ti.ti-calendar:before {\r\n    content: 'P'\r\n}\r\n\r\n.ti.ti-check:before {\r\n    content: 'N'\r\n}\r\n\r\n.ti.ti-image:before {\r\n    content: ','\r\n}\r\n\r\n.ti.ti-file:before {\r\n    content: '%'\r\n}\r\n\r\n.ti.ti-file-pdf:before {\r\n    content: '('\r\n}\r\n\r\n.ti.ti-file-powerpoint:before {\r\n    content: ')'\r\n}\r\n\r\n.ti.ti-file-word:before {\r\n    content: '+'\r\n}\r\n\r\n.ti.ti-file-excel:before {\r\n    content: '&'\r\n}\r\n\r\n.ti.ti-list:before {\r\n    content: 'A'\r\n}\r\n\r\n.ti.ti-user-circle:before {\r\n    content: '6'\r\n}\r\n\r\n.ti.ti-id-card:before {\r\n    content: '7'\r\n}\r\n\r\n.ti.ti-user-group:before {\r\n    content: '8'\r\n}\r\n\r\n.ti.ti-bell:before {\r\n    content: 'Q'\r\n}\r\n\r\n.ti.ti-info-circle:before {\r\n    content: '/'\r\n}\r\n\r\n.ti.ti-eye:before {\r\n    content: '\"'\r\n}\r\n\r\n.ti.ti-eye-slash:before {\r\n    content: \"'\"\r\n}\r\n\r\n/* sizing */\r\n.text-sm, .text-sm * {\r\n    font-size: .75rem !important;\r\n}\r\n\r\n.text-xs {\r\n    font-size: .5rem !important;\r\n}\r\n\r\n.text-md, .text-md * {\r\n    font-size: 1.25rem !important;\r\n}\r\n\r\n.text-lg, .text-lg * {\r\n    font-size: 1.5rem !important;\r\n}\r\n\r\n.text-xl, .text-xl * {\r\n    font-size: 2rem !important;\r\n}\r\n\r\n.text-super, .text-super * {\r\n    font-size: 5rem !important;\r\n}\r\n\r\n.text-normal, .text-normal * {\r\n    font-size: 1rem !important;\r\n}\r\n\r\n.text-red {\r\n    color: red !important;\r\n}\r\n\r\n.text-green {\r\n    color: green !important;\r\n}\r\n\r\n.text-orange {\r\n    color: orange !important;\r\n}\r\n\r\n.text-lime-green {\r\n    color: #88ff88 !important;\r\n}\r\n\r\n.text-white {\r\n    color: white !important;\r\n}\r\n\r\n.text-gray {\r\n    color:#999 !important;\r\n}\r\n\r\n.text-blue {\r\n    color: #005377;\r\n}\r\n\r\n.text-bold {\r\n    font-weight: bold;\r\n}\r\n\r\n.text-italic {\r\n    font-style: italic;\r\n}\r\n\r\n.text-weight-normal {\r\n    font-weight: normal !important;\r\n}\r\n\r\n.text-underline {\r\n    text-decoration: underline !important;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .text-increase-phone .btn,\r\n    .text-increase-phone {\r\n        font-size: 108% !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
